const leadsApiUrl = window.leadsConfig.leadsApiUrl;

const getLeadsApiUrl = () => {
  return leadsApiUrl;
};

export default { getLeadsApiUrl };
